// GA4 Event tracking helper functions
import { trackEvent } from './components/GoogleAnalytics';

/**
 * Tracks form opening events in Google Analytics
 * @param formName The name of the form being opened
 * @param additionalParams Optional additional parameters to track
 */
export const trackFormOpen = (formName: string, additionalParams: Record<string, any> = {}) => {
  trackEvent('form_opened', {
    form_name: formName,
    ...additionalParams
  });
};

/**
 * Tracks form submission events in Google Analytics
 * @param formName The name of the form being submitted
 * @param additionalParams Optional additional parameters to track
 */
export const trackFormSubmit = (formName: string, additionalParams: Record<string, any> = {}) => {
  trackEvent('form_submitted', {
    form_name: formName,
    ...additionalParams
  });
}; 